import "./App.css";
import "antd/dist/reset.css";
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import NavBar from "./pages/components/NavBar";
import logo from "./pages/utils/assets/login-illustration.png";
import MyCourse from "./pages/courses/MyCourse";
import Home from "./pages/Home";
import OtpVerification from "./pages/users/OtpVerification";
import SessionManagement from "./pages/users/SessionMangement";
import LoginPage from "./pages/users/LoginPage";
import AdminHomePage from "./pages/users/admin/AdminHomePage";
import UsersAdmin from "./pages/users/admin/UsersAdmin";
import StudentDetails from "./pages/users/admin/StudentDetails";
import AdminDetails from "./pages/users/admin/AdminDetails";
import OperationsDetails from "./pages/users/admin/OperationsDetails";
import InstructorDetails from "./pages/users/admin/InstructorDetails";
import Courses from "./pages/courses/admin/Courses";
import EditCourse from "./pages/courses/admin/EditCourse";
import CourseContentRouter from "./pages/courses/admin/CourseContentRouter";
import CourseDetails from "./pages/courses/admin/CourseDetails";
import ClassDetails from "./pages/courses/admin/ClassDetails";
import CoursesOperations from "./pages/courses/operations/CoursesOperations";
import CourseDetailsOperations from "./pages/courses/operations/CourseDetailsOperations";
import CourseContentRouterOperations from "./pages/courses/operations/CourseContentRouterOperations";
import CoursesInstructor from "./pages/courses/instructor/CoursesInstructor";
import CourseDetailsInstructor from "./pages/courses/instructor/CourseDetailsInstructor";
import CourseContentRouterInstructor from "./pages/courses/instructor/CourseContentRouterInstructor";
import CoursesStudent from "./pages/courses/student/CoursesStudent";
import CourseDetailsStudent from "./pages/courses/student/CourseDetailsStudent";
import CourseContentRouterStudent from "./pages/courses/student/CourseContentRouterStudent";
import ClassDetailsStudent from "./pages/courses/student/ClassDetailsStudent";
import MockInterviewInstructor from "./pages/courses/instructor/MockInterviewInstructor";
import MockInterviewStudent from "./pages/courses/student/MockInterviewStudent";
import MockInterviewDetails from "./pages/courses/student/MockInterviewDetails";
import MockInterviewLive from "./pages/courses/student/MockInterviewLive";
import MockInterviewCompleted from "./pages/courses/student/MockInterviewCompleted";
import OperationsHomePage from "./pages/courses/operations/OperationsHomePage";
import InstructorHomePage from "./pages/courses/instructor/InstructorHomePage";
import StudentHomePage from "./pages/courses/student/StudentHomePage";
import ProtectedRoute from "./ProtectedRoute";
import JobsStudent from "./pages/courses/student/JobsStudent";
import JobsInstructor from "./pages/courses/instructor/JobsInstructor";
import JobCardDetails from "./pages/courses/instructor/JobCardDetails";
import JobCardDetailsStudent from "./pages/courses/student/JobCardDetailsStudent";
import ProfileInstructor from "./pages/courses/instructor/ProfileInstructor";
import JobsAdmin from "./pages/courses/admin/JobsAdmin";
import JobsOperations from "./pages/courses/operations/JobsOperations";
import ProfileStudent from "./pages/courses/student/ProfileStudent";
import ResetPassword from "./pages/users/ResetPassword";
import ProfileAdmin from "./pages/courses/admin/ProfileAdmin";
import ProfileOperations from "./pages/courses/operations/ProfileOperations";
import Chats from "./pages/courses/admin/Chats";
import ChatsOperations from "./pages/courses/operations/ChatsOperations";
import ChatsStudent from "./pages/courses/student/ChatsStudent";
import Resources from "./pages/courses/admin/Resources";
import ChatsInstructor from "./pages/courses/instructor/ChatsInstructor";
import DashBoards from "./pages/courses/admin/DashBoards";
import DashBoardsOperations from "./pages/courses/operations/DashBoardsOperations";
// Loader component
function Loader({ logoSrc }) {
  return (
    <div
      className="app-loader"
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className="app-loader-inner">
        <div className="app-loader-ring" aria-hidden="true"></div>
        <img
          src={logoSrc}
          alt="Practical Infosec"
          className="app-loader-logo"
        />
      </div>
    </div>
  );
}

// Handles showing loader on route change
function AppContent() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initial load
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);



  useEffect(() => {
    const path = location.pathname;
    let pageTitle = "Practical Infosec";

    const role = (localStorage.getItem("role") || "").toUpperCase();

    const ROLE_HOME_TITLES = {
      ADMIN: "Admin Home",
      INSTRUCTOR: "Instructor Home",
      OPERATIONS: "Operations Home",
      STUDENT: "Student Home",
    };

    /* ===========================
     ROLE HOME PAGE
  =========================== */

    if (path.startsWith("/user/") && path.includes("home-page")) {
      pageTitle = `${ROLE_HOME_TITLES[role] || "Home"} | Practical Infosec`;
    } else if (path.startsWith("/academy/")) {
      /* ===========================
     ACADEMY PAGES
  =========================== */
      // Remove '/academy/'
      const cleanPath = path.replace("/academy/", "");

      // Split path parts
      const segments = cleanPath.split("/");

      // Take LAST segment only
      const lastSegment = segments[segments.length - 1];

      // Format title
      const formattedTitle = lastSegment
        .replace(/-/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());

      pageTitle = `${formattedTitle} | Practical Infosec`;
    }

    document.title = pageTitle;
  }, [location]);

  const hideNavbarRoutes = ["/session-management"];

  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

  return (
    <>
      {loading && <Loader logoSrc={logo} />}

      {!shouldHideNavbar && <NavBar />}

      <Routes>
        <Route path="/user/sign_in" element={<LoginPage />} />
        <Route path="/user/verify-otp" element={<OtpVerification />} />
        <Route path="/session-management" element={<SessionManagement />} />
        <Route path="/academy/my-courses" element={<MyCourse />} />
        <Route path="/" element={<Home />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Courses ADMIN*/}
        
          <Route path="/user/admin-home-page" element={<ProtectedRoute allowedRoles={["ADMIN"]} ><AdminHomePage /> </ProtectedRoute>} />
        <Route path="/academy/admin/users" element={<ProtectedRoute allowedRoles={["ADMIN"]} ><UsersAdmin /> </ProtectedRoute>} />
        <Route
          path="/academy/admin/users/student/:id"
          element={<ProtectedRoute allowedRoles={["ADMIN"]} ><StudentDetails /> </ProtectedRoute>}
        />
        <Route
          path="/academy/admin/users/admin/:id"
          element={<ProtectedRoute allowedRoles={["ADMIN"]} ><AdminDetails /> </ProtectedRoute>}
        />
        <Route
          path="/academy/admin/users/operations/:id"
          element={<ProtectedRoute allowedRoles={["ADMIN"]} ><OperationsDetails /> </ProtectedRoute>}
        />
        <Route
          path="/academy/admin/users/instructor/:id"
          element={<ProtectedRoute allowedRoles={["ADMIN"]} ><InstructorDetails /> </ProtectedRoute>}
        />
        
        <Route path="/academy/admin/courses-management" element={<ProtectedRoute allowedRoles={["ADMIN"]} ><Courses /> </ProtectedRoute>} />
        <Route
          path="/academy/admin/courses/:courseName/edit/:id"
          element={<ProtectedRoute allowedRoles={["ADMIN"]} ><EditCourse /> </ProtectedRoute>}
        />

        <Route
          path="/academy/admin/courses/:courseName/course-content"
          element={<ProtectedRoute allowedRoles={["ADMIN"]} ><CourseContentRouter /> </ProtectedRoute>}
        />

        <Route
          path="/academy/admin/courses/:id/details"
          element={<ProtectedRoute allowedRoles={["ADMIN"]} ><CourseDetails /> </ProtectedRoute>}
        />

        <Route
          path="/academy/admin/courses/:CourseName/course-content/class/:id"
          element={<ProtectedRoute allowedRoles={["ADMIN"]} ><ClassDetails /> </ProtectedRoute>}
        />
         <Route
          path="/academy/admin/jobs"
          element={<ProtectedRoute allowedRoles={["ADMIN"]} ><JobsAdmin /> </ProtectedRoute>}
        />
        
        <Route
          path="/academy/admin/jobs/:id/job-details"
          element={<ProtectedRoute allowedRoles={["ADMIN"]} ><JobCardDetails /> </ProtectedRoute>}
        />
        <Route path="/academy/admin/chats" element={<ProtectedRoute allowedRoles={["ADMIN"]} ><Chats /> </ProtectedRoute>} />

        <Route
          path="/academy/admin/dashboards"
          element={<ProtectedRoute allowedRoles={["ADMIN"]} ><DashBoards /> </ProtectedRoute>}
        />

        <Route
          path="/academy/admin/tickets"
          element={<ProtectedRoute allowedRoles={["ADMIN"]} ><DashBoards /> </ProtectedRoute>}
        />
        
       <Route
          path="/academy/admin/resources-hub"
          element={<ProtectedRoute allowedRoles={["ADMIN"]} ><Resources /> </ProtectedRoute>}
        />

        
       
        <Route path="/user/admin/profile" element={<ProtectedRoute allowedRoles={["ADMIN"]} ><ProfileAdmin /> </ProtectedRoute>} />






      {/* Operations courses  */}
       <Route path="/academy/operations/courses" element={<ProtectedRoute allowedRoles={["OPERATIONS"]} ><CoursesOperations /> </ProtectedRoute>} />
       <Route
          path="/academy/operations/courses/details/:id"
          element={<ProtectedRoute allowedRoles={["OPERATIONS"]} ><CourseDetailsOperations /> </ProtectedRoute>}
        />
        
      <Route
          path="/academy/operations/courses/:courseName/edit/:id"
          element={<ProtectedRoute allowedRoles={["OPERATIONS"]} ><EditCourse /> </ProtectedRoute>}
        />
        <Route
          path="/academy/operations/courses/:courseName/course-content"
          element={<ProtectedRoute allowedRoles={["OPERATIONS"]} ><CourseContentRouterOperations /> </ProtectedRoute>}
        />
        <Route
          path="/academy/operations/courses/course-content/:CourseName/:id/class"
          element={<ProtectedRoute allowedRoles={["OPERATIONS"]} ><ClassDetails /> </ProtectedRoute>}
        />

        <Route
          path="/academy/operations/jobs"
          element={<ProtectedRoute allowedRoles={["OPERATIONS"]} ><JobsOperations /> </ProtectedRoute>}
        />

        <Route
          path="/academy/operations/jobs/:id/job-details"
          element={<ProtectedRoute allowedRoles={["OPERATIONS"]} ><JobCardDetails /> </ProtectedRoute>}
        />

         <Route
          path="/academy/operations/chats"
          element={<ProtectedRoute allowedRoles={["OPERATIONS"]} ><ChatsOperations /> </ProtectedRoute>}
        />

        <Route
          path="/academy/operations/resources-hub"
          element={<ProtectedRoute allowedRoles={["OPERATIONS"]} ><Resources /> </ProtectedRoute>}
        />

        <Route
          path="/academy/operations/dashboards"
          element={<ProtectedRoute allowedRoles={["OPERATIONS"]} ><DashBoardsOperations /> </ProtectedRoute>}
        />

        <Route
          path="/academy/operations/tickets"
          element={<ProtectedRoute allowedRoles={["OPERATIONS"]} ><DashBoardsOperations /> </ProtectedRoute>}
        />
        
        <Route path="/user/operations-home-page" element={<ProtectedRoute allowedRoles={["OPERATIONS"]} ><OperationsHomePage /> </ProtectedRoute>} />
        <Route path="/user/operations/profile" element={<ProtectedRoute allowedRoles={["OPERATIONS"]} ><ProfileOperations /> </ProtectedRoute>} />







        {/* Instructor course Routes*/}
        <Route path="/academy/mentor-dashboard/my-batches" element={<ProtectedRoute allowedRoles={["INSTRUCTOR"]} ><CoursesInstructor /> </ProtectedRoute>} />
         <Route
          path="/academy/mentor-dashboard/course/details/:id"
          element={<ProtectedRoute allowedRoles={["INSTRUCTOR"]} ><CourseDetailsInstructor /> </ProtectedRoute>}
        />
        <Route
          path="/academy/mentor-dashboard/course/:courseName/course-content/modules"
          element={<ProtectedRoute allowedRoles={["INSTRUCTOR"]} ><CourseContentRouterInstructor /> </ProtectedRoute>}
        />
         <Route
          path="/academy/mentor-dashboard/course/course-content/:CourseName/modules/:id/class"
          element={<ProtectedRoute allowedRoles={["INSTRUCTOR"]} ><ClassDetails /> </ProtectedRoute>}
        />

         <Route
          path="/academy/mentor-dashboard/mock-interviews"
          element={<ProtectedRoute allowedRoles={["INSTRUCTOR"]} ><MockInterviewInstructor /> </ProtectedRoute>}
        />

        <Route
          path="/academy/mentor-dashboard/mock-interviews"
          element={<ProtectedRoute allowedRoles={["INSTRUCTOR"]} ><MockInterviewInstructor /> </ProtectedRoute>}
        />
        <Route
          path="/academy/mentor-dashboard/jobs"
          element={<ProtectedRoute allowedRoles={["INSTRUCTOR"]} ><JobsInstructor /> </ProtectedRoute>}
        />

        <Route
          path="/academy/mentor-dashboard/jobs/:id/job-details"
          element={<ProtectedRoute allowedRoles={["INSTRUCTOR"]} ><JobCardDetails /> </ProtectedRoute>}
        />

        <Route
          path="/academy/mentor-dashboard/resources-hub"
          element={<ProtectedRoute allowedRoles={["INSTRUCTOR"]} ><Resources /> </ProtectedRoute>}
        />

        <Route
          path="/academy/mentor-dashboard/chats"
          element={<ProtectedRoute allowedRoles={["INSTRUCTOR"]} ><ChatsInstructor /> </ProtectedRoute>}
        />

        <Route path="/user/instructor-home-page" element={<ProtectedRoute allowedRoles={["INSTRUCTOR"]} ><InstructorHomePage /> </ProtectedRoute>} />
         <Route path="/user/mentor-dashboard/profile" element={<ProtectedRoute allowedRoles={["INSTRUCTOR"]} ><ProfileInstructor /> </ProtectedRoute>} />
        
 
 
        {/* Student Courses Routes */}

         <Route path="/academy/mentee-dashboard/my-courses" element={<ProtectedRoute allowedRoles={["STUDENT"]} ><CoursesStudent /> </ProtectedRoute>} />
          <Route
          path="/academy/mentee-dashboard/:id/active/course-details"
          element={<ProtectedRoute allowedRoles={["STUDENT"]} ><CourseDetailsStudent /> </ProtectedRoute>}
        />
        <Route
          path="/academy/mentee-dashboard/course/:courseName/course-content/active/modules"
          element={<ProtectedRoute allowedRoles={["STUDENT"]} ><CourseContentRouterStudent /> </ProtectedRoute>}
        />
        <Route
          path="/academy/mentee-dashboard/course/course-content/:CourseName/modules/:id/active/class"
          element={<ProtectedRoute allowedRoles={["STUDENT"]} ><ClassDetailsStudent /> </ProtectedRoute>}
        />
        <Route
          path="/academy/mentee-dashboard/all-active-mock-interviews"
          element={<ProtectedRoute allowedRoles={["STUDENT"]} ><MockInterviewStudent /> </ProtectedRoute>}
        />

        <Route
          path="/academy/mentee-dashboard/mock-interviews/:id/details"
          element={<ProtectedRoute allowedRoles={["STUDENT"]} ><MockInterviewDetails /> </ProtectedRoute>}
        />

        <Route
          path="/academy/mentee-dashboard/mock-interview/:id/upcoming-mock-interview"
          element={<ProtectedRoute allowedRoles={["STUDENT"]} ><MockInterviewLive /> </ProtectedRoute>}
        />
        <Route
          path="/academy/mentee-dashboard/mock-interview/:id/completed-mock-interview"
          element={<ProtectedRoute allowedRoles={["STUDENT"]} ><MockInterviewCompleted /> </ProtectedRoute>}
        />

        <Route
          path="/academy/mentee-dashboard/jobs"
          element={<ProtectedRoute allowedRoles={["STUDENT"]} ><JobsStudent /> </ProtectedRoute>}
        />
        
        <Route
          path="/academy/mentee-dashboard/jobs/:id/job-details"
          element={<ProtectedRoute allowedRoles={["STUDENT"]} ><JobCardDetails /> </ProtectedRoute>}
        />

        <Route
          path="/academy/mentee-dashboard/chats"
          element={<ProtectedRoute allowedRoles={["STUDENT"]} ><ChatsStudent /> </ProtectedRoute>}
        />

         <Route
          path="/academy/mentee-dashboard/resources-hub"
          element={<ProtectedRoute allowedRoles={["STUDENT"]} ><Resources /> </ProtectedRoute>}
        />
        
        <Route path="/user/student-home-page" element={<ProtectedRoute allowedRoles={["STUDENT"]} ><StudentHomePage /> </ProtectedRoute>} />
        <Route path="/user/mentee-dashboard/profile" element={<ProtectedRoute allowedRoles={["STUDENT"]} ><ProfileStudent /> </ProtectedRoute>} />

        
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
